export default __webpack_public_path__ + "static/scandinavia-6c40480f44b23d5d4bc09dc57457c482.svg";